import React  from "react";
import { useParams, useLocation } from 'react-router-dom';
import EmployeeDocuments from "./components/EmployeeDocuments";

const ViewEmployeeDetail = () => {
	const { detailId } = useParams();  
	const location = useLocation();
	
	const recordData = location.state?.recordData;
    
    return (
        <EmployeeDocuments recordId={detailId} recordData={recordData}  mode="view"/>
    );
};

export default ViewEmployeeDetail;